import { logData } from '../../utils/debug.util';
import { IPendingSurvey, ISurvey, ISurveyResponse } from './survey-types';
import AdacaAPI from '..';

const findSurvey = async (file: string) => {
  const { data } = await AdacaAPI.get(`/Survey/${file}`);
  return data;
};

/** Obtiene las encuestas pendientes de responder para un expediente. */
const findPendingSurveys = async (file: string): Promise<IPendingSurvey[]> => {
  const { data } = await AdacaAPI.get<IPendingSurvey[]>(`/Survey/pending/${file}`);
  return data || [];
};

/** Indica si un expediente tiene alguna encuesta pendiente de responder. */
const existPendingSurveys = async (file: string): Promise<boolean> => {
  const { data } = await AdacaAPI.get<number>(`/Survey/exist/${file}`);
  logData('Exist pending surveys data:', data);
  return data > 0;
};

const getSurveyQuestions = async (file: string, intervention: string) => {
  const { data, status } = await AdacaAPI.get<ISurvey>(`/Survey/questions/${file}/${intervention}`);
  return { data, status };
};

const sendSurvey = async (body?: ISurveyResponse) => {
  if (!body) return;
  const { data } = await AdacaAPI.post(`/Survey`, body);
  return data;
};

export { getSurveyQuestions, findSurvey, findPendingSurveys, sendSurvey, existPendingSurveys };
